import { Route } from "@dashboard/components/Router";
import { WindowTitle } from "@dashboard/components/WindowTitle";
import React from "react";
import { Switch } from "react-router-dom";

import { analyticsPath } from "./urls";
import AnalyticsPage from "./views/AnalyticsPage/AnalyticsPage";

export const AnalyticsSection: React.FC = () => {
  return (
    <>
      <WindowTitle title="Analytics & Reports" />
      <Switch>
        <Route exact path={analyticsPath} component={AnalyticsPage} />
        <Route component={AnalyticsPage} />
      </Switch>
    </>
  );
};

export default AnalyticsSection;
